const id = {
  menuLogs: "Log",
  logDescription:
    "Pantau semua aktivitas penting di akun Anda secara real-time",
  logType: "Tipe Log",
  logTime: "Waktu Log",
  logDate: "Tanggal",
  logActivity: "Aktivitas",
  logTypes: "Tipe",
  logDownloadAudit: "Download Log Audit",
  logChoose: "Pilih",
  logDownloadLogs: "Download Logs",
  fileXlsx: "File .xlsx",
  fileCsv: "File .csv",
  logLogin: "Login",
  logUser: "User",
  logBrowserSettings: "Pengaturan",
  logTemplateAndCampaign: "Template dan campaign",
  logDataUpload: "Data upload",
  logCustomerService: "Customer service",
  logReport: "Report",
  logFrom: "Dari",
  logTo: "Sampai (maks. 30 hari)",
  logDownloadFileType: "Tipe file",
  logSelect: "Pilih",
};

const en = {
  menuLogs: "Log",
  logDescription:
    "Monitor all important activities in your account in real-time",
  logType: "Log Type",
  logTime: "Log Time",
  logDate: "Date",
  logActivity: "Activity",
  logTypes: "Type",
  logDownloadAudit: "Download Audit Log",
  logChoose: "Choose",
  logDownloadLogs: "Download Logs",
  fileXlsx: "File .xlsx",
  fileCsv: "File .csv",
  logLogin: "Login",
  logUser: "User",
  logBrowserSettings: "Browser settings",
  logTemplateAndCampaign: "Template and campaign",
  logDataUpload: "Data upload",
  logCustomerService: "Customer service",
  logReport: "Report",
  logFrom: "From",
  logTo: "To (max 30 days)",
  logDownloadFileType: "File type",
  logSelect: "Select",
};

export default { id, en };
